module.exports = __webpack_public_path__ + "static/img/10.fdf48c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/10.png
// module id = bTAt
// module chunks = 0